import React from 'react'

export default function FaceFeature({ scaleX, fill, outline }) {
  return (
    <g transform={`scale(${scaleX},1)`} fill="none">
      <path
        d="M5.51998 42.4317C5.51998 42.4317 5.82997 28.1317 9.27997 21.5217C13.72 13.0317 19.27 4.23169 19.27 4.23169C19.27 4.23169 7.65998 8.74169 4.14998 15.7917C1.06998 21.9717 0.449976 30.7617 5.51998 42.4317Z"
        fill={fill}
        stroke={outline}
        strokeWidth="2"
        strokeMiterlimit="10"
      />
      <path
        d="M54.1399 42.4317C54.1399 42.4317 53.8299 28.1317 50.3799 21.5217C45.9399 13.0317 40.3899 4.23169 40.3899 4.23169C40.3899 4.23169 51.9999 8.74169 55.5099 15.7917C58.5899 21.9717 59.2199 30.7617 54.1399 42.4317Z"
        fill={fill}
        stroke={outline}
        strokeWidth="2"
        strokeMiterlimit="10"
      />
      <path
        d="M33.5899 9.23156C32.5799 8.80156 31.5299 8.52156 30.4799 8.29156C29.4299 8.08156 28.3699 7.93156 27.2999 7.90156C26.2399 7.87156 25.1599 7.89156 24.0999 8.04156C23.0299 8.16156 21.9699 8.37156 20.8799 8.59156C21.8599 8.10156 22.8999 7.68157 23.9999 7.46157C25.0799 7.19157 26.2099 7.14156 27.3299 7.15156C28.4499 7.19156 29.5599 7.39157 30.6299 7.72157C31.6999 8.06157 32.7199 8.54156 33.5899 9.23156Z"
        fill={outline}
      />
      <path
        d="M34.1599 7.52158C33.0699 6.99158 31.9199 6.64157 30.7699 6.34157C29.6199 6.06157 28.4499 5.86158 27.2699 5.78158C26.0899 5.71158 24.8999 5.68157 23.7199 5.79157C22.5299 5.87157 21.3499 6.05157 20.1399 6.23157C20.6999 6.00157 21.2699 5.79158 21.8599 5.61158C22.4499 5.47158 23.0399 5.28158 23.6499 5.21158C24.8599 4.98158 26.0999 4.97157 27.3299 5.04157C29.7699 5.25157 32.2499 5.98158 34.1599 7.52158Z"
        fill={outline}
      />
      <path
        d="M34.8799 6.1118C33.8999 5.5618 32.8899 5.1318 31.8599 4.7618C30.8299 4.4018 29.7799 4.1018 28.7099 3.9218C27.6399 3.7318 26.5599 3.6118 25.4699 3.6118C24.3799 3.5818 23.2799 3.69179 22.1599 3.79179C23.2099 3.40179 24.3099 3.0918 25.4499 3.0218C26.5799 2.9018 27.7299 2.9818 28.8499 3.1718C29.9699 3.3718 31.0699 3.72181 32.0899 4.21181C33.1099 4.70181 34.0699 5.3318 34.8799 6.1118Z"
        fill={outline}
      />
      <path
        d="M38.14 4.5217C37.44 3.4417 36.54 2.6617 35.5 2.0817C34.98 1.7917 34.43 1.57169 33.85 1.37169C33.27 1.18169 32.67 1.0117 32.05 0.831696C32.37 0.771696 32.69 0.761689 33.02 0.731689C33.34 0.751689 33.67 0.751697 33.99 0.801697C34.64 0.901697 35.27 1.11169 35.86 1.43169C37.02 2.08169 38 3.2117 38.14 4.5217Z"
        fill={outline}
      />
      <path
        d="M35.8699 5.38158C35.3099 4.86158 34.7199 4.40158 34.1299 3.96158C33.5299 3.53158 32.9199 3.13157 32.2699 2.79157C30.9899 2.08157 29.5999 1.64157 28.1099 1.26157C28.8699 1.17157 29.6599 1.16158 30.4199 1.33158C31.1899 1.47158 31.9299 1.76157 32.6199 2.12157C33.9899 2.87157 35.1899 3.98158 35.8699 5.38158Z"
        fill={outline}
      />
    </g>
  )
}
